import { Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { NavigableTreeNode } from '../../types';
import useTreeContext from '../../context/useTreeContext';

interface ButtonProps {
  node: NavigableTreeNode;
}

export default function TreeItemExpandButton({ node }: Readonly<ButtonProps>) {
  const { handleItemToggle } = useTreeContext();

  return (
    <Stack
      role='presentation'
      component='span'
      data-testid='expand-button'
      justifyContent='center'
      alignItems='center'
      tabIndex={-1}
      onClick={(e) => {
        handleItemToggle(node);
        e.preventDefault();
        e.stopPropagation();
      }}
      flexShrink={0}
      sx={{ height: 24, width: 24 }}
    >
      {node.isLoading && <span aria-hidden='true'>{'⌛'}</span>}
      {!node.isLoading && !node.isExpanded && (
        <AddIcon aria-hidden='true' fontSize='small' />
      )}
      {!node.isLoading && node.isExpanded && (
        <RemoveIcon aria-hidden='true' fontSize='small' />
      )}
    </Stack>
  );
}
